import { DateTime } from 'luxon';
import React, { useEffect } from 'react';
import { ImageBackground, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { AppHeader, Loader } from '../../../components/common';
import { AppText } from '../../../components/form';
import { NoClassesAvailable } from '../../../components/worker';
import ClassItem from '../../../components/worker/ClassItem';
import { getClasses } from '../../../redux/actions/workerActions';
import { handleProgress } from '../onlineGym';
import styles from '../onlineGym/styles';

const inPersonGym = ({ navigation }) => {
  const { isLoading, classesData, workerData } = useSelector((state) => state.worker);
  const now = DateTime.now().toFormat('dd/LL/yyyy');
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getClasses('PRESENCIAL', workerData));
  }, []);
  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title={'Ginástica Laboral\nPresencial'} hasBack navigation={navigation} />

      {
          isLoading ? <Loader />
            : (classesData.length ? (
              <ScrollView style={styles.content}>
                <AppText size="bold" style={styles.textTitle}>{`PROGRAMAÇÃO ${now}`}</AppText>

                {classesData.map((item, index) => <ClassItem key={`ClassItem-${index}`} index={index} item={item} navigation={navigation} progress={handleProgress(item)} />)}
              </ScrollView>

            )

              : <NoClassesAvailable />
            )
            }

    </ImageBackground>
  );
};

export default inPersonGym;
